function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { convertToPutEventsRequest } from './event-request-adapter';
const RETRYABLE_CODES = [429, 500];
export class EventBuffer {
  constructor(pinpointClient, eventBufferConfig) {
    _defineProperty(this, "eventBufferConfig", {
      bufferSize: 1000,
      flushSize: 100,
      flushInterval: 5 * 1000,
      resendLimit: 5
    });
    _defineProperty(this, "buffer", void 0);
    _defineProperty(this, "pinpointClient", void 0);
    this.eventBufferConfig = {
      ...this.eventBufferConfig,
      ...eventBufferConfig
    };
    this.pinpointClient = pinpointClient;
    this.buffer = [];
    this.setUpIntervalFlush();
  }
  setUpIntervalFlush() {
    setInterval(() => {
      this.flush();
    }, this.eventBufferConfig.flushInterval);
  }
  push(event) {
    if (this.buffer.length < this.eventBufferConfig.bufferSize) {
      this.buffer.push({
        ...event,
        attempts: 0
      });
      if (event.immediate || this.buffer.length === this.eventBufferConfig.bufferSize) {
        this.flush(event.immediate);
      }
    }
  }
  async flush(immediate) {
    if (this.buffer.length === 0) {
      return;
    }
    const eventsRequestBatch = this.buffer.map(convertToPutEventsRequest).reduce((acc, cur) => {
      Object.keys(cur.batchItem).forEach(key => {
        if (acc.batchItem[key]) {
          acc.batchItem[key].events = {
            ...acc.batchItem[key].events,
            ...cur.batchItem[key].events
          };
        } else {
          acc.batchItem[key] = cur.batchItem[key];
        }
      });
      return acc;
    });
    const bufferSnapshot = [...this.buffer];
    this.buffer = [];
    let result;
    try {
      if (immediate) {
        await this.pinpointClient.putEventBySendBeacon(eventsRequestBatch);
        return;
      }
      result = await this.pinpointClient.putEvent(eventsRequestBatch);
    } catch {
      this.buffer.unshift(...bufferSnapshot);
      return;
    }
    const eligibleRetryEvents = [];
    Object.keys(result).forEach(key => {
      const response = result[key];
      Object.keys(response.eventsItemResponse).forEach(eventId => {
        if (RETRYABLE_CODES.includes(response.eventsItemResponse[eventId].statusCode)) {
          const eligibleRetryEvent = bufferSnapshot.find(item => item.eventId === eventId);
          if (eligibleRetryEvent && eligibleRetryEvent.attempts < this.eventBufferConfig.resendLimit) {
            eligibleRetryEvent.attempts++;
            eligibleRetryEvents.push(eligibleRetryEvent);
          }
        }
      });
    });
    this.buffer.unshift(...eligibleRetryEvents);
  }
  getBuffer() {
    return [...this.buffer];
  }
}